export const currentFilters = {
  "label": "File formats",
  "isSearchable": true,
  "filters": [
      {
          "value": "84",
          "label": "MP4 (.mp4)",
      },
      {
          "value": "68",
          "label": "Beyond3D (.b3d)",
      },
      {
          "value": "67",
          "label": "MilkShape 3D  (.ms3d)",
      },
      {
          "value": "66",
          "label": "Torque (.dts)",
      },
      {
          "value": "65",
          "label": "DarkBASIC Object (.dbo)",
      },
      {
          "value": "64",
          "label": "X file (.x)",
      },
      {
          "value": "63",
          "label": "Leaderwerks (.gmf)",
      },
      {
          "value": "62",
          "label": "Universal 3D (.u3d)",
      },
      {
          "value": "61",
          "label": "Alias/WaveFront Material (.mtl)",
      },
      {
          "value": "60",
          "label": "Cheetah3D (.jas)",
      },
      {
          "value": "59",
          "label": "SolidWorks (.sldprt, .sldasm, .slddrw)",
      },
      {
          "value": "55",
          "label": "Zbrush (.ztl)",
      },
      {
          "value": "54",
          "label": "Vue (.vue)",
      },
      {
          "value": "70",
          "label": "Solid Edge (.asm)",
      },
      {
          "value": "71",
          "label": "Autodesk Inventor (.ipt)",
      },
      {
          "value": "83",
          "label": "Unity 3D (.unitypackage)",
      },
      {
          "value": "82",
          "label": "Jewelry Cad (.jcad, .jcd)",
      },
      {
          "value": "81",
          "label": "Marvelous Designer Pose (.pos)",
      },
      {
          "value": "80",
          "label": "Marvelous Designer Avatar (.avt)",
      },
      {
          "value": "79",
          "label": "Marvelous Designer Project (*.ZPrj, .ZPrj)",
      },
      {
          "value": "78",
          "label": "Marvelous Designer Garment  (.zpac)",
      },
      {
          "value": "77",
          "label": "Alibre/Geomagic Design Package (.ad_pkg)",
      },
      {
          "value": "76",
          "label": "Alibre/Geomagic Sheetmetal (.ad_smp)",
      },
      {
          "value": "75",
          "label": "Alibre/Geomagic Drawing (.ad_dwg)",
      },
      {
          "value": "74",
          "label": "Alibre/Geomagic Assm (.ad_asm)",
      },
      {
          "value": "73",
          "label": "Alibre/Geomagic Part (.ad_prt)",
      },
      {
          "value": "72",
          "label": "Step (.stp)",
      },
      {
          "value": "53",
          "label": "VRML (.wrl, .wrz)",
      },
      {
          "value": "51",
          "label": "Stereolithography (.stl)",
      },
      {
          "value": "17",
          "label": "3D Studio Max (.max)",
      },
      {
          "value": "15",
          "label": "Softimage (.hrc, .xsi)",
      },
      {
          "value": "14",
          "label": "Sketchup (.skp)",
      },
      {
          "value": "13",
          "label": "Rhino (.3dm)",
      },
      {
          "value": "12",
          "label": "OBJ (.obj)",
      },
      {
          "value": "11",
          "label": "Maya (.ma, .mb)",
      },
      {
          "value": "8",
          "label": "Lightwave (.lwo, .lw, .lws)",
      },
      {
          "value": "7",
          "label": "DXF (.dxf)",
      },
      {
          "value": "6",
          "label": "Cinema 4D (.c4d)",
      },
      {
          "value": "5",
          "label": "Autodesk FBX (.fbx)",
      },
      {
          "value": "4",
          "label": "AutoCAD (.dwg)",
      },
      {
          "value": "2",
          "label": "3D Studio (.3ds)",
      },
      {
          "value": "21",
          "label": "Blender (.blend)",
      },
      {
          "value": "23",
          "label": "Bryce (.br5, .obp)",
      },
      {
          "value": "48",
          "label": "Silo (.sia)",
      },
      {
          "value": "47",
          "label": "Shockwave 3D (.w3d)",
      },
      {
          "value": "44",
          "label": "Revit Models (.rvt)",
      },
      {
          "value": "42",
          "label": "Renderman (.rib, .slc, .sl, .slo)",
      },
      {
          "value": "40",
          "label": "Poser (.pz3, .pp2)",
      },
      {
          "value": "38",
          "label": "OpenFlight (.flt)",
      },
      {
          "value": "35",
          "label": "Maxwell Scene (.mxs)",
      },
      {
          "value": "33",
          "label": "Luxology Modo (.lxo)",
      },
      {
          "value": "30",
          "label": "Inventor Assembly (.iam)",
      },
      {
          "value": "29",
          "label": "IGES (.ige, .igs, .iges)",
      },
      {
          "value": "26",
          "label": "DirectX (.X)",
      },
      {
          "value": "25",
          "label": "Collada (.dae)",
      },
      {
          "value": "1",
          "label": "Revit Family (.rfa)",
      },
  ],
}
